import { HttpHeaders } from '@angular/common/http';

/**
 * 
 * @param responseType default json
 * @param observe default body
 * @param params 
 */
export const httpOptions = (responseType?:'arraybuffer'|'blob'|'json'|'text', observe?:'body' | 'events' | 'response', params?:any, reportProgress?:boolean) : any => {
    let httpOptions:any = { 
        //responseType: responseType||undefined,
        //observe: responseType=='blob'?'response':undefined,
        reportProgress: reportProgress,
        responseType: responseType||undefined,
        observe: observe||undefined,
        params: params
    } 

    if(localStorage.getItem('access_token'))
        httpOptions.headers = new HttpHeaders({'Authorization':`Bearer ${localStorage.getItem('access_token')}`})

    return httpOptions;
}